import { Component, effect, ChangeDetectionStrategy } from '@angular/core';
import { FormArray } from '@angular/forms';
import { Register } from '@xanadu/core';
import { InputComponent } from '@xanadu/input';

@Component({
    selector: 'app-images',
    templateUrl: './images.component.html',
    styleUrls: ['./images.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('images')
export class ImagesComponent extends InputComponent {
    metaImage: any;

    images: string[] = [];
    imagesArray: FormArray<any> = new FormArray<any>([]);

    constructor(
    ) {
        super();

        effect(() => {
            const model = this.model();
            const meta = this.meta();
            const formGroup = this.formGroup();

            if (model && meta && formGroup) {
                this.images = model;

                this.metaImage = { name: 'Url', info: 'Image url', pattern: meta?.pattern };
                formGroup?.addControl(meta.id, this.imagesArray);
            }
        });
    }

    onAdd() {
        this.images.push('');
    }

    onDelete(index: number) {
        this.images.splice(index, 1);
        this.imagesArray.removeAt(index);
        this.formGroup()?.markAsDirty();
    }
}
